var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('survey', {
    attrs: {
      "detailsData": _vm.surveyDetails,
      "loading": _vm.loading,
      "isSuccessLoad": _vm.isSuccessLoad,
      "isFinished": _vm.isFinished,
      "submitLoading": _vm.submitLoading
    },
    on: {
      "submit": _vm.handleSubmit
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };